module.exports = __webpack_public_path__ + "static/media/sni.7a6000f5.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/sni.png
// module id = 1588
// module chunks = 0